import { apiClient } from './client';

export interface OilProvinceFeatureProperties {
  id: string;
  name: string;
}

export interface OilProvinceFeature {
  type: 'Feature';
  id?: string;
  properties: OilProvinceFeatureProperties;
  geometry: {
    type: string;
    coordinates: unknown;
  };
}

export interface OilProvinceGeoJSON {
  type: 'FeatureCollection';
  features: OilProvinceFeature[];
}

export interface OilProvinceAttributeRange {
  attribute_id: string;
  attribute_name: string;
  unit?: string | null;
  min_value: number;
  max_value: number;
}

export interface OilProvinceDetail {
  id: string;
  name: string;
  ranges: OilProvinceAttributeRange[];
}

export const oilProvincesApi = {
  getGeoJSON: async (simplify = 0.05): Promise<OilProvinceGeoJSON> => {
    return apiClient.get<OilProvinceGeoJSON>('/oil-provinces/', {
      params: { simplify },
      timeout: 120000,
    });
  },

  getProvince: async (provinceId: string): Promise<OilProvinceDetail> => {
    return apiClient.get<OilProvinceDetail>(`/oil-provinces/${provinceId}`);
  },
};
